<template>
  <div class="breadcrumbs">
    <span v-for="(item, itemIndex) in items" :key="itemIndex" class="_crumb">
      <router-link v-if="item.url" :to="item.url">{{ item.title }}</router-link>
      <span v-else>{{ item.title }}</span>
    </span>
  </div>
</template>

<script>
export default {
  name: "BreadCrumbs",
  components: {},
  props: {
    items: Array,
  },
}
</script>

<style lang="scss">
.breadcrumbs {
  margin-bottom: 20px;
  font-size: 1.4rem;
  color: #777;
  display: flex;
  gap: 12px;
  ._crumb + ._crumb {
    position: relative;
    &::before {
      content: "/";
      position: absolute;
      left: -8px;
      top: 0;
    }
  }
  a {
    color: #777;
  }
}
</style>
